// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1ji0g","col":"styles_col__1byD2"};